import { ORGANIZATIONENTITES } from "../definitions";

const initialState = {
  enitiesData: null,
  affiliationsData: null,
  isOrganizationCalled: false,
};

const entityOrganizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORGANIZATIONENTITES.INITIATE_ORGANIZATION_ENITIES_FETCH: {
      return {
        ...state,
        enitiesData: null,
      };
    }
    case ORGANIZATIONENTITES.ORGANIZATION_ENITIES_SUCCESS: {
      return {
        ...state,
        enitiesData: action.payload,
        error: null,
      };
    }
    case ORGANIZATIONENTITES.ORGANIZATION_ENITIES_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case ORGANIZATIONENTITES.ORGANIZATION_ENITIES_FINAL: {
      return {
        ...state,
        error: action.payload,
        isOrganizationCalled: true,
      };
    }
    case ORGANIZATIONENTITES.INITIATE_ORGANIZATION_AFFILIATIONS: {
      return {
        ...state,
        affiliationsData: null,
      };
    }
    case ORGANIZATIONENTITES.ORGANIZATION_AFFILIATIONS_SUCCESS: {
      return {
        ...state,
        affiliationsData: action.payload,
        error: null,
      };
    }
    case ORGANIZATIONENTITES.ORGANIZATION_AFFILIATIONS_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export { entityOrganizationReducer };
